export const selectLiveNotifications = (state) =>
  state?.notification?.notifications;

export const selectLiveTasks = (state) => state?.notification?.tasks;
